import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import { toggleModal } from "../../../shared-components/modals/actions";

import { fetchPaidPartConfig } from "./actions";

import ConfigurePaidPartModal from "./ConfigurePaidPartModal";

import { BONUS_CHAPTER_TYPE } from "../../../constants";

import {
  DEFAULT_DATA_VALUES,
  PaidPartDataProps,
  MODAL_BUTTON_CONTENT
} from "./constants";
import { Loader } from "../../../shared-components";
import { useFeatureFlags } from "../../../hooks";

const ConfigurePaidPartModalButton = ({
  isLoading,
  story,
  partId,
  authorId,
  paidPartData,
  fetchPaidPartConfig
}) => {
  const dispatch = useDispatch();
  const featureflags = useFeatureFlags();

  const COPY = MODAL_BUTTON_CONTENT();

  useEffect(
    () => {
      fetchPaidPartConfig(story.id, partId);
    },
    [story, partId, fetchPaidPartConfig]
  );

  const createConfigModal = () => (
    <ConfigurePaidPartModal {...{ story, partId, authorId, paidPartData }} />
  );

  const handleOpenModalClick = () => {
    if (isLoading) return;

    dispatch(
      toggleModal({
        hideClose: true,
        disableClose: true,
        disableScroll: true,
        useGlobalModalContainer: true,
        className: "configure-paid-part-modal-container",
        component: () => createConfigModal()
      })
    );
  };

  return (
    <div
      className={classNames(
        "configure-paid-part-modal-preview",
        !paidPartData.is_free_part && "is-paid-bonus-chapter"
      )}
    >
      <div className="configure-paid-part-modal-button">
        {isLoading && (
          <div className="configure-paid-part-loader">
            <Loader />
          </div>
        )}
        {!isLoading && (
          <button
            className={classNames("btn btn-purple bonus-btn", {
              "new-writer-actions": featureflags.PUBLISHING_SCHEDULER
            })}
            onClick={handleOpenModalClick}
          >
            {paidPartData.is_free_part && COPY.button.default}
            {!paidPartData.is_free_part && (
              <>
                {COPY.button.text}{" "}
                {paidPartData.bonus_type ==
                  BONUS_CHAPTER_TYPE.EXCLUSIVE_CHAPTER &&
                  COPY.display.type.exclusiveChapter}
                {paidPartData.bonus_type == BONUS_CHAPTER_TYPE.WRITER_REVEAL &&
                  COPY.display.type.writerReveal}
                {paidPartData.bonus_type == BONUS_CHAPTER_TYPE.STORY_BRANCH &&
                  COPY.display.type.storyBranch}
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

ConfigurePaidPartModalButton.defaultProps = {
  paidPartData: DEFAULT_DATA_VALUES
};

ConfigurePaidPartModalButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  story: PropTypes.object.isRequired,
  partId: PropTypes.number.isRequired,
  authorId: PropTypes.number.isRequired,
  fetchPaidPartConfig: PropTypes.func.isRequired,
  paidPartData: PaidPartDataProps
};

const mapStateToProps = state => {
  return {
    paidPartData: state.paidPartConfig.data,
    isLoading: state.paidPartConfig.isLoading
  };
};

export default connect(
  mapStateToProps,
  { fetchPaidPartConfig }
)(ConfigurePaidPartModalButton);
